import { isEmpty } from "lodash"
import React, { MouseEventHandler, useEffect, useState } from "react"
import { Button, Col, Dropdown, Form, InputGroup, Modal, Row, Table } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import EditIcon from "../../assets/edit.svg"
import TrashIcon from "../../assets/trash.svg"
import { SERVICE_TYPE } from "../../constants/constants"
import { RootState } from "../../store"
import CreateOrUpdateSurchrage from "./CreateOrUpdateSurchrage"

const PricingRateModal = ({
    loading,
    show,
    setShow,
    shippingRateDetails,
    setShippingRateDetails,
    handleClose,
    handleSubmit
}: {
    loading: boolean
    show: string
    setShow: Function
    shippingRateDetails: Record<string, any>
    setShippingRateDetails: Function
    handleClose: Function
    handleSubmit: Function
}) => {
    const { t } = useTranslation()
    const [total, setTotal] = useState(0)
    const [error, setError] = useState("")
    const { surcharges, surchargeLoading } = useAppSelector((state: RootState) => state.pricing)
    const [surchargeData, setSurchargeData] = useState({} as Record<string, any>)
    const [addedSurcharges, setAddedSurcharges] = useState([] as Record<string, any>[])
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (shippingRateDetails?.id) {
            setTotal(shippingRateDetails?.rate)
        }
        if (error && error !== "") {
            setError("")
        }
        if (
            shippingRateDetails?.WeightRateSurcharges &&
            shippingRateDetails?.WeightRateSurcharges?.length > 0
        ) {
            // const tempSurcharges = surcharges.filter((s: Record<string, any>) =>
            //     shippingRateDetails?.WeightRateSurcharges?.map((ss: Record<string, any>) => ss?.shipping_surcharge_id)?.includes(s?.id)
            // )
            setAddedSurcharges([...shippingRateDetails?.WeightRateSurcharges])
        } else {
            setAddedSurcharges([])
        }
    }, [
        shippingRateDetails?.id,
        shippingRateDetails?.rate,
        shippingRateDetails?.WeightRateSurcharges?.length,
        surcharges?.length
    ])

    const handleDeleteSurcharge = (surcharge: Record<string, any>) => {
        const surchargeValue =
            surcharge?.type === SERVICE_TYPE["0"]
                ? parseFloat(surcharge?.default_value)
                : (parseFloat(surcharge?.default_value) / 100) * parseFloat(shippingRateDetails?.base_charge)
        calculateTotalSurcharges(surchargeValue, "REMOVED_SURCHARGE", 0, false)
        setAddedSurcharges(addedSurcharges?.filter((addedSurcharge) => addedSurcharge?.id !== surcharge?.id))
    }

    const calculateTotalSurcharges = (
        surchargeValue: number,
        surcharge: string,
        oldSurchargeValue: number,
        firstSurcharge: boolean
    ) => {
        let tempTotal: number = 0
        let tempSurcharge: number = 0
        switch (surcharge) {
            case "ADDED_SURCHARGE":
                const tempOldValue = firstSurcharge
                    ? parseFloat(shippingRateDetails?.surcharge)
                    : oldSurchargeValue
                tempTotal = surchargeValue + (total - tempOldValue)
                tempSurcharge = firstSurcharge ? tempSurcharge : parseFloat(shippingRateDetails?.surcharge)
                tempSurcharge = tempSurcharge - oldSurchargeValue + surchargeValue
                break
            case "REMOVED_SURCHARGE":
                tempTotal = total - surchargeValue
                tempSurcharge = parseFloat(shippingRateDetails?.surcharge)
                tempSurcharge = tempSurcharge - surchargeValue
                break
            default:
                tempTotal = surchargeValue + (total - oldSurchargeValue)
                tempSurcharge = parseFloat(shippingRateDetails?.surcharge)
                tempSurcharge = tempSurcharge - oldSurchargeValue + surchargeValue
                break
        }

        tempTotal = tempTotal > 0 ? tempTotal : tempTotal * -1
        tempSurcharge = tempSurcharge >= 0 ? tempSurcharge : tempSurcharge * -1
        setTotal(parseFloat(tempTotal.toFixed(2)))
        setShippingRateDetails({
            ...shippingRateDetails,
            surcharge: parseFloat(tempSurcharge?.toFixed(2)),
            new_rate: ((parseFloat(shippingRateDetails?.margin) * tempTotal) / 100 + tempTotal)?.toFixed(2)
        })
    }

    return (
        <Modal
            size={"lg"}
            show={show === "shippingRateModal"}
            onHide={() => {
                setShow(false)
                setShippingRateDetails(null)
                setAddedSurcharges([])
            }}
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {shippingRateDetails?.id ? (
                        <>
                            {" "}
                            {t("Updating shipping rate of #")}&nbsp;{shippingRateDetails?.id}{" "}
                        </>
                    ) : (
                        <> {t("Create new shipping rate")} </>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="shipping-rate-modal">
                {shippingRateDetails?.id ? (
                    <>
                        <Row className="d-flex justify-content-around">
                            <Col lg={12}>
                                <Row className={"container"}>
                                    <Col lg={4}>
                                        <Form.Group>
                                            <Form.Label htmlFor="base">{t("Base")}</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Control
                                                    id="base"
                                                    type="number"
                                                    autoComplete="off"
                                                    name={"base_charge"}
                                                    value={
                                                        parseFloat(
                                                            shippingRateDetails?.base_charge?.toFixed(2)
                                                        ) || 0
                                                    }
                                                    onChange={(e: any) => {
                                                        if (parseFloat(e.target.value) > 0) {
                                                            setError("")
                                                        } else {
                                                            setError("Base cannot be 0 or less.")
                                                        }
                                                        const tempTotal =
                                                            parseFloat(e.target.value) +
                                                            parseFloat(shippingRateDetails?.surcharge)
                                                        setTotal(tempTotal)
                                                        setShippingRateDetails({
                                                            ...shippingRateDetails,
                                                            base_charge: parseFloat(e.target.value),
                                                            new_rate: (
                                                                (parseFloat(shippingRateDetails?.margin) *
                                                                    tempTotal) /
                                                                    100 +
                                                                tempTotal
                                                            )?.toFixed(2)
                                                        })
                                                    }}
                                                    placeholder="Base"
                                                    isInvalid={error !== ""}
                                                />
                                                <InputGroup.Text>$</InputGroup.Text>
                                                {error && error !== "" && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {t(`${error}`)}
                                                    </Form.Control.Feedback>
                                                )}
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Group>
                                            <Form.Label htmlFor="surcharge">{t("Surcharge")}</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Control
                                                    id="surcharge"
                                                    type="number"
                                                    autoComplete="off"
                                                    name={"surcharge"}
                                                    disabled={addedSurcharges?.length > 0}
                                                    value={
                                                        parseFloat(
                                                            shippingRateDetails?.surcharge?.toFixed(2)
                                                        ) || 0
                                                    }
                                                    onChange={(e: any) => {
                                                        calculateTotalSurcharges(
                                                            parseFloat(e?.target?.value) || 0,
                                                            "",
                                                            shippingRateDetails?.surcharge,
                                                            false
                                                        )
                                                    }}
                                                    placeholder="Surcharge"
                                                />
                                                <InputGroup.Text>$</InputGroup.Text>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Group>
                                            <Form.Label htmlFor="total">{t("Total")}</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Control
                                                    id="total"
                                                    type="number"
                                                    name={"total"}
                                                    value={total?.toFixed(2)}
                                                    minLength={12}
                                                    readOnly
                                                    placeholder="Total"
                                                />
                                                <InputGroup.Text>$</InputGroup.Text>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6} md={6} sm={12} xs={12}>
                                        <Form.Group>
                                            <Form.Label htmlFor="margin">{t("Margin")}</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Control
                                                    id="margin"
                                                    type="number"
                                                    autoComplete="off"
                                                    name={"margin"}
                                                    value={shippingRateDetails?.margin || 0}
                                                    minLength={12}
                                                    onChange={(e: any) =>
                                                        setShippingRateDetails({
                                                            ...shippingRateDetails,
                                                            margin: parseFloat(e.target.value),
                                                            new_rate: (
                                                                (parseFloat(e.target.value) * total) / 100 +
                                                                total
                                                            )?.toFixed(2)
                                                        })
                                                    }
                                                    placeholder="Margin"
                                                />
                                                <InputGroup.Text>%</InputGroup.Text>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6} md={6} sm={12} xs={12}>
                                        <Form.Group>
                                            <Form.Label htmlFor="new_rate">{t("New Rate")}</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Control
                                                    id="new_rate"
                                                    type="number"
                                                    autoComplete="off"
                                                    value={shippingRateDetails?.new_rate || 0}
                                                    minLength={12}
                                                    readOnly
                                                    placeholder="New Rate"
                                                />
                                                <InputGroup.Text>%</InputGroup.Text>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    {addedSurcharges?.length > 0 && (
                                        <div className="table-responsive">
                                            <Table>
                                                <thead className="custom-thead border-bottom-0">
                                                    <tr className="border rounded">
                                                        <th className="col-4">Surcharge</th>
                                                        <th className="col-3">Value</th>
                                                        <th className="col-3">Flat/%</th>
                                                        <th className="col-2">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-start custom-tbody">
                                                    {addedSurcharges?.map((surcharge: Record<string, any>) =>
                                                        !isEmpty(surchargeData) &&
                                                        surchargeData?.id === surcharge?.id ? (
                                                            <CreateOrUpdateSurchrage
                                                                surchargeData={surchargeData}
                                                                setSurchargeData={setSurchargeData}
                                                                handleDeletingSurcharge={handleDeleteSurcharge}
                                                                error={error}
                                                                setError={setError}
                                                                shippingRateDetails={shippingRateDetails}
                                                                calculateTotalSurcharges={
                                                                    calculateTotalSurcharges
                                                                }
                                                                surcharges={addedSurcharges}
                                                                setSurcharges={setAddedSurcharges}
                                                            />
                                                        ) : (
                                                            <tr
                                                                className="rounded justify-content-around"
                                                                key={`${surcharge?.id}-surcharge`}>
                                                                <td className="col-4">
                                                                    <span>{surcharge?.name}</span>
                                                                </td>
                                                                <td className="col-3">
                                                                    <span>
                                                                        {surcharge?.default_value}
                                                                        {surcharge?.default_type !==
                                                                            SERVICE_TYPE["0"] &&
                                                                            ` (${(
                                                                                ((parseFloat(
                                                                                    surcharge?.default_value
                                                                                ) || 0) /
                                                                                    100) *
                                                                                parseFloat(
                                                                                    shippingRateDetails?.base_charge
                                                                                )
                                                                            )?.toFixed(2)} $)`}
                                                                    </span>
                                                                </td>
                                                                <td className="col-3">
                                                                    <span>
                                                                        {surcharge?.default_type ===
                                                                        SERVICE_TYPE["0"]
                                                                            ? "$"
                                                                            : "%"}
                                                                    </span>
                                                                </td>
                                                                <td className="col-2 d-flex justify-content-start">
                                                                    <img
                                                                        src={EditIcon}
                                                                        onClick={() => {
                                                                            setSurchargeData({ ...surcharge })
                                                                        }}
                                                                        className="tr-pointer"
                                                                    />
                                                                    <img
                                                                        src={TrashIcon}
                                                                        onClick={() =>
                                                                            handleDeleteSurcharge(surcharge)
                                                                        }
                                                                        className="tr-pointer ml-2"
                                                                    />
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                    {/* {!isEmpty(surchargeData) && !surchargeData?.id &&
                                                        <CreateOrUpdateSurchrage
                                                            surchargeData={surchargeData}
                                                            setSurchargeData={setSurchargeData}
                                                            handleSubmit={() => {
                                                                dispatch(createSurcharge({ newSurchargeData: surchargeData as CreateSurchargeRequest }))
                                                            }}
                                                            error={error}
                                                            setError={setError}
                                                        />
                                                    } */}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}
                                    {surcharges?.length - addedSurcharges?.length > 0 && (
                                        <Dropdown className="actions-menu d-flex justify-content-end">
                                            <Dropdown.Toggle
                                                className="dashed-border"
                                                id="dropdown-basic"
                                                size={"sm"}>
                                                + {t("Surcharge")}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                {surcharges
                                                    ?.filter(
                                                        (s) =>
                                                            !addedSurcharges
                                                                ?.map((as) => as?.id)
                                                                .includes(s?.id)
                                                    )
                                                    ?.map((s: Record<string, any>) => (
                                                        <Dropdown.Item
                                                            key={s?.id}
                                                            onClick={() => {
                                                                const firstSurcharge =
                                                                    addedSurcharges?.length === 0 ? true : false
                                                                setAddedSurcharges([...addedSurcharges, s])
                                                                const surchargeValue =
                                                                    s.type === SERVICE_TYPE["0"]
                                                                        ? parseFloat(s?.default_value)
                                                                        : (parseFloat(s?.default_value) / 100) *
                                                                          parseFloat(
                                                                              shippingRateDetails?.base_charge
                                                                          )
                                                                calculateTotalSurcharges(
                                                                    parseFloat(surchargeValue.toFixed(2)),
                                                                    "ADDED_SURCHARGE",
                                                                    0,
                                                                    firstSurcharge
                                                                )
                                                            }}>
                                                            {s?.name}
                                                        </Dropdown.Item>
                                                    ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                </Row>
                            </Col>
                        </Row>
                    </>
                ) : null}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose as MouseEventHandler<HTMLButtonElement>}>
                    {t("Close")}
                </Button>

                <Button
                    onClick={() => {
                        const tempAddedSurcharges = addedSurcharges?.map(
                            (addedSurcharge: Record<string, any>) => ({
                                shipping_surcharge_id: addedSurcharge?.id,
                                surcharge_value: addedSurcharge?.default_value,
                                surcharge_type: addedSurcharge?.type
                            })
                        )
                        handleSubmit({
                            ...shippingRateDetails,
                            surcharges: [...tempAddedSurcharges]
                        })
                        handleClose()
                    }}
                    disabled={error !== ""}
                    className="btn btn-primary"
                    type="submit">
                    {surchargeLoading ? (
                        <div className="spinner-border text-light" role="submit"></div>
                    ) : shippingRateDetails?.id ? (
                        t("Update")
                    ) : (
                        t("Submit")
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default PricingRateModal
